import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import { Button } from '../components/ui/Button';

export function NotFound() {
  const { t } = useI18n();
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-bg px-6 text-center">
      <span className="type-display-xl text-accent tnum">404</span>
      <p className="type-body text-secondary mt-2">{t.errors.notFound}</p>
      <div className="mt-6">
        <Link to="/">
          <Button size="lg">{t.common.brand}</Button>
        </Link>
      </div>
    </div>
  );
}
